import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const AustraliaIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM11.0817 4.40702C11.0112 4.19544 10.8283 4.04104 10.6079 4.00699C10.3875 3.97294 10.1665 4.06497 10.0354 4.2454L9.36571 5.1673L9.18307 5.33789L8.85435 5.18437V4.59525C8.85435 4.26651 8.58785 4.00001 8.25911 4.00001H7.37076C7.17486 4.00001 6.99149 4.09641 6.88043 4.25779L6.39157 4.96809H5.66808C5.47577 4.96809 5.29531 5.061 5.18359 5.21753L4.1818 6.62114L3.18895 7.54853C3.0057 7.71969 2.94937 7.98734 3.04808 8.21784L4.0845 10.638C4.14795 10.7862 4.2688 10.9023 4.41941 10.9598C4.57001 11.0173 4.73749 11.0112 4.88355 10.943L6.83664 10.0309H7.95265L8.81103 11.2335C8.92275 11.3901 9.10322 11.483 9.29553 11.483H10.8501C11.001 11.483 11.1462 11.4257 11.2565 11.3227L12.2929 10.3547C12.3623 10.2898 12.4152 10.2092 12.4472 10.1197L12.9654 8.66762C13.027 8.49498 13.0056 8.30359 12.9074 8.14879L11.6879 6.22571L11.0817 4.40702ZM9.68323 12.1462C9.41774 12.1462 9.24506 12.4256 9.36379 12.663L9.6359 13.2073C9.6964 13.3282 9.82006 13.4047 9.95534 13.4047H10.1431C10.2784 13.4047 10.4021 13.3282 10.4626 13.2073L10.7347 12.663C10.8534 12.4256 10.6807 12.1462 10.4152 12.1462H9.68323Z"
		/>
	</svg>
))
